import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import RouteTransition from "./components/ui/RouteTransition";
import NotFound from "./pages/NotFound";
import Homepage from "./pages/homepage";
import ServicesPage from "./pages/services-page";
import TechnologiesPage from "./pages/technologies-page";
import TestimonialsPage from "./pages/testimonials-page";
import ContactPage from "./pages/contact-page";
import AboutUsPage from "./pages/about-us";
import SubmitReview from "./pages/submit-review";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouteTransition>
          <RouterRoutes>
            <Route path="/home" element={<Homepage />} />
            <Route path="/" element={<Homepage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/technologies" element={<TechnologiesPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/submit-review" element={<SubmitReview />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </RouteTransition>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
